import React from 'react';
import autres from './../../../../assets/images/svg/051-parents.svg';
import children from './../../../../assets/images/svg/002-children.svg';
import noChildren from './../../../../assets/images/svg/002-nochildren.svg';
import homechildren from './../../../../assets/images/svg/002-homechildren.svg';

import celibataireW from './../../../../assets/images/svg/001-W-celibataire.svg';
import unionsW from './../../../../assets/images/svg/001-W-unions.svg';
import divorceeW from './../../../../assets/images/svg/001-W-divorcee.svg';
import veuveW from './../../../../assets/images/svg/001-W-veuve.svg';

import celibataireM from './../../../../assets/images/svg/001-M-celibataire.svg';
import unionsM from './../../../../assets/images/svg/001-M-unions.svg';
import divorceeM from './../../../../assets/images/svg/001-M-divorcee.svg';
import veuveM from './../../../../assets/images/svg/001-M-veuve.svg';

import { ModalFamily } from './modals/modalFamily';

export const Family = ({deathDeclaration, userId, isLoading}) => {
    const familyStatusText = [
        {},
        { 'Male': {label:'Célibataire', logo:celibataireM}, 'Female': {label:'Célibataire', logo:celibataireW} },
        { 'Male': {label:'Marié', logo:unionsM}, 'Female': {label:'Mariée', logo:unionsW} },
        { 'Male': {label:'Divorcé', logo:divorceeM}, 'Female': {label:'Divorcée', logo:divorceeW} },
        { 'Male': {label:'Veuf', logo:veuveM}, 'Female': {label:'Veuve', logo:veuveW} },
        { 'Male': {label:'Union libre', logo:unionsM}, 'Female': {label:'Union libre', logo:unionsW} },
        { 'Male': {label:'Pacsé', logo:unionsM}, 'Female': {label:'Pacsée', logo:unionsW} }
    ];
    
    var civilStatus = deathDeclaration.civilStatus;
    if (!civilStatus || civilStatus < 1 || civilStatus >= familyStatusText.length) {
        civilStatus = 1;
    }
    //#region etat civil
    const genderKey = (deathDeclaration.gender === 'Female' || deathDeclaration.gender === 1) ? 'Female' : 'Male';
    const statusEntry = familyStatusText[civilStatus];
    let familyStatus = statusEntry?.[genderKey] || { label: '', logo: null };

    

    let childrenLogo = deathDeclaration.hasChildren ? children : noChildren;

    return (
        <section className="card mb-sm">
            <div className="card-header pb-0">
                <div className="grid grid-sm-2 align-items-center">
                    <h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">SITUATION FAMILIALE</h2>
                    <div className="grid grid-2 ml-sm-auto align-items-center">
                        <button type="button" data-toggle="modal" data-target="#familyModal" className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-edit-2-outline align-middle fs-lead"></i></button>
                        <div className="custom-control custom-switch mx-auto">
                            <input type="checkbox" className="custom-control-input" id="familySwitchCheckDefault1" required="required"  defaultChecked={deathDeclaration.onBoardingStep > 3} />
                            <label className="custom-control-label" htmlFor="familySwitchCheckDefault1">Valider</label>
                        </div>
                    </div>
                </div>
                <hr className="mb-0" />
            </div>
            <div className="card-body grid grid-sm-2 grid-lg-3 grid-xl-5 gy-3">
                <div className="block flex-row align-items-center">
                    <img className="img-fluid mr-3 h-4" src={familyStatus.logo} alt="autres" />
                    <p className="h6 text-uppercase font-weight-bold my-auto o-70">{familyStatus.label}</p>
                </div>
                <div className="flex-row align-items-start">
                    <img className="img-fluid mr-3 h-4" src={deathDeclaration.hasChildren ? children : noChildren} alt="children" />
                    <p className="h6 text-uppercase font-weight-bold my-auto o-70">{deathDeclaration.hasChildren ? "" : "Pas d'"}enfants</p>
                </div>
                <div className="flex-row align-items-center grid-column-xl-2">
                    <img className="img-fluid mr-3 h-4" src={homechildren} alt="autres" />
                    <div className="my-auto">
                        <p className="h6 text-uppercase font-weight-bold my-auto o-40">autre personne dans le foyer</p>
                        <p className="h6 text-uppercase font-weight-bold my-auto">{deathDeclaration.houseHoldCount} personne(s)</p>
                    </div>
                </div>
            </div>
            <ModalFamily deathDeclaration={deathDeclaration} userId={userId} isLoading={isLoading} />
        </section>
    )
}